Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
CardMemberSelectView = require 'views/card/card-member-select-view'
DatePickerView = require 'views/card/date-picker-view'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'

UP_NEXT_TYPE = 'UP_NEXT'
HIGHLIGHT_TYPE = 'HIGHLIGHTS'
DUE_DATE_TYPE = 'DUE_DATES'

getTrackingMethod = (type, menuItemName) =>
  return if type == UP_NEXT_TYPE
    "by clicking #{menuItemName} menu item on up next card"
  else if type == HIGHLIGHT_TYPE
    "by clicking #{menuItemName} menu item on highlights card"
  else if type == DUE_DATE_TYPE
    "by clicking #{menuItemName} menu item on due dates card"

onCardSubscriptionClick = (card, type, trackingPrepositionalObject) =>
  isSubscribed = card.isSubscribed()

  actionVerb = if isSubscribed then 'unsubscribes' else 'subscribes'
  menuItemName = if isSubscribed then 'unsubscribe' else 'subscribe'
  method = getTrackingMethod(type, menuItemName)
  trackUe('home', actionVerb, 'card', trackingPrepositionalObject, '', method, { cardId: card.id })

  card.subscribe(!isSubscribed)
  PopOver.hide()

onClickAddDueDate = (card, type, modelCache, trackingIndirectObject) =>
  actionVerb = if card.getDueDate()? then 'changes' else 'adds'
  method = getTrackingMethod(type, 'due date')
  trackUe('home', actionVerb, 'due date', '', trackingIndirectObject, method, { cardId: card.id })

  PopOver.pushView
    view: DatePickerView
    options: { model: card, modelCache }

onClickAddMembersToCard = (card, type, modelCache, trackingIndirectObject) =>
  method = getTrackingMethod(type, 'members')
  trackUe('home', 'changes', 'members', '', trackingIndirectObject, method, { cardId: card.id })

  PopOver.pushView
    view: CardMemberSelectView
    options: { model: card, modelCache }

onClickJoinCard = (card, type, modelCache, trackingIndirectObject) =>
  method = getTrackingMethod(type, 'join card')
  trackUe('home', 'joins', 'card', '', trackingIndirectObject, method, { cardId: card.id })

  card.addMember(Auth.myId())
  PopOver.hide()

onClickLeaveCard = (card, type, modelCache, trackingIndirectObject) =>
  method = getTrackingMethod(type, 'leave card')
  trackUe('home', 'leaves', 'card', '', trackingIndirectObject, method, { cardId: card.id })

  card.removeMember(Auth.myId())
  PopOver.hide()

getFilteredOverflowItems = (itemKeys, card, type, modelCache, trackingPrepositionalObject, trackingIndirectObject) => [
  {
    key: 'subscribe',
    name: l('home card overflow menu title.watch')
    onClick: onCardSubscriptionClick.bind(null, card, type, trackingPrepositionalObject)
    shouldShow: !card.isSubscribed()
  }, {
    key: 'unsubscribe'
    name: l('home card overflow menu title.stop watching')
    onClick: onCardSubscriptionClick.bind(null, card, type, trackingPrepositionalObject)
    shouldShow: card.isSubscribed()
  }, {
    key: 'addDueDate'
    name: l('home card overflow menu title.add due date')
    onClick: onClickAddDueDate.bind(null, card, type, modelCache, trackingIndirectObject)
    shouldShow: !card.getDueDate()? && card.editable()
  }, {
    key: 'changeDueDate'
    name: l('home card overflow menu title.change due date')
    onClick: onClickAddDueDate.bind(null, card, type, modelCache, trackingIndirectObject)
    shouldShow: card.getDueDate()? && card.editable()
  }, {
    key: 'addMembers'
    name: l('home card overflow menu title.add members to card')
    onClick: onClickAddMembersToCard.bind(null, card, type, modelCache, trackingIndirectObject)
    shouldShow: card.editable()
  }, {
    key: 'joinCard'
    name: l('home card overflow menu title.join card')
    onClick: onClickJoinCard.bind(null, card, type, modelCache, trackingIndirectObject)
    shouldShow: !card.hasMember(Auth.myId()) && card.editable()
  }, {
    key: 'leaveCard'
    name: l('home card overflow menu title.leave card')
    onClick: onClickLeaveCard.bind(null, card, type, modelCache, trackingIndirectObject)
    shouldShow: card.hasMember(Auth.myId()) && card.editable()
  }
].filter((item) -> itemKeys[item.key] && item.shouldShow)

getOverflowItems = (card, type, modelCache, trackingPrepositionalObject = '', trackingIndirectObject = '') =>
  itemKeys = if type == UP_NEXT_TYPE
    subscribe: true
    unsubscribe: true
    addDueDate: true
    changeDueDate: true
    addMembers: true
  else if type == HIGHLIGHT_TYPE
    subscribe: true
    unsubscribe: true
    joinCard: true
    leaveCard: true
  else if type == DUE_DATE_TYPE
    subscribe: true
    unsubscribe: true
    addMembers: true
  else
    throw new Error('invalid type')

  return getFilteredOverflowItems(itemKeys, card, type, modelCache, trackingPrepositionalObject, trackingIndirectObject)

module.exports = {
  getOverflowItems
  UP_NEXT_TYPE
  HIGHLIGHT_TYPE
  DUE_DATE_TYPE
}



// WEBPACK FOOTER //
// ./app/scripts/views/home/overflow-menu.coffee